export default {
    brush: {
        title: 'Brush',
        brushHardness: 'Brush hardness',
        brushSize: 'Brush size',
        brushColor: 'Brush color',
    },
};
